export default __webpack_public_path__ + "static/media/coupon_received_on.8631633f.png";